import React from "react";
import registry from "./nodes";
import resolveProps from "./resolveProps";
import TextNode from "./TextNode";
// Các component cần đọc AST node để xử lý slot children
const NODE_AWARE_COMPONENTS = new Set([
    "input",
    "textarea",
    "wizard",
    "state",
    "box_group",
    "box_radio_group",
    "box_checkbox_group",
    "radio_group",
    "checkbox_group",
    "dangerously",
    "dag",
    "svg",
    "if",
]);

const LAZY_CHILD_COMPONENTS = new Set([
    "if",
    "repeat",
    "wizard",
    "state",
]);

export function renderNode(node: any, key?: number, ctx?: any): any {
  let type = node?.type ? `${node?.type}`.trim(): null;
  if (node.type === "text") {
    return <TextNode key={key} content={node.content} context={ctx} />;
  }

  if (type === "set") {
    const target = ctx || {};
    const props = node.props || {};
    const force = Boolean(props.force);

    Object.entries(props).forEach(([key, value]) => {
      if (key === "force") return;
      if (force || target[key] === undefined) {
        target[key] = value;
      }
    });

    return null;
  }

  let Comp = null;
  try{
    Comp = registry[type];
  }catch (e) {
    debug('type', node.type);
    debug(e);
  }

  if (!Comp) return null;

  const props = resolveProps(node, ctx);

  const children = LAZY_CHILD_COMPONENTS.has(type || "")
      ? undefined
      : node.children?.map((child: any, i: number) =>
          renderNode(child, i, ctx)
      );

  let newProps = { ...props };

  if ((["include", "repeat", "if"].includes(type || ""))) {
    Object.assign(newProps, { partials: ctx?.partials, context: ctx });
  }

  if (type === "repeat") {
    Object.assign(newProps, { node });
  }

  if (type === "wizard") {
    Object.assign(newProps, { context: ctx });
  }

  if (type === "state") {
    Object.assign(newProps, { context: ctx });
  }

  if (["box_group", "box_radio_group", "box_checkbox_group"].includes(type || "")) {
    Object.assign(newProps, { context: ctx });
  }

  if (["radio_group", "checkbox_group"].includes(type || "")) {
    Object.assign(newProps, { context: ctx });
  }

  if (["dag", "dangerously", "svg"].includes(type || "")) {
    Object.assign(newProps, { context: ctx });
  }

  // ✅ Chỉ truyền node xuống các component cần đọc AST (slot-aware)
  // Các component còn lại KHÔNG nhận node để tránh forward vào DOM
  if (NODE_AWARE_COMPONENTS.has(type || "")) {
    Object.assign(newProps, { node });
  }

  return (
      <Comp key={key} {...newProps}>
        {children}
      </Comp>
  );
}


export default renderNode;
